import React from 'react';
import { AlertTriangle, CheckCircle2, Lock, X, ArrowRight } from 'lucide-react';
type ExitIntentPopupProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function ExitIntentPopup({
  isOpen,
  onClose
}: ExitIntentPopupProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 overflow-y-auto" data-id="element-485">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full my-auto relative" data-id="element-486">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors z-10" aria-label="Close" data-id="element-487">
          <X className="w-6 h-6 text-gray-500" data-id="element-488" />
        </button>

        {/* HEADER BANNER */}
        <div className="bg-brand-dark text-center pt-8 pb-6 px-6 rounded-t-2xl relative overflow-hidden" data-id="element-489">
          <div className="absolute top-0 left-0 right-0 bg-red-600 text-white text-xs font-bold uppercase tracking-widest py-1.5" data-id="element-490">
            LIMITED-TIME OFFER — THIS SCREEN ONLY
          </div>
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-white mt-4 mb-3 flex items-center justify-center gap-2" data-id="element-491">
            <AlertTriangle className="w-8 h-8 text-brand-gold flex-shrink-0" data-id="element-492" />
            WAIT — You're Leaving Money on the Table!
          </h2>
          <p className="text-gray-300 text-sm md:text-base max-w-lg mx-auto" data-id="element-493">
            What if you could unlock your COMPLETE benefit recovery system for
            less than a cup of coffee per resource?
          </p>
        </div>

        {/* BODY */}
        <div className="p-6 md:p-8" data-id="element-494">
          <div className="flex justify-center mb-6" data-id="element-495">
            <div className="inline-block text-white font-bold text-sm md:text-base uppercase tracking-wider px-6 py-2 rounded-full shadow-md badge-flash-anim" data-id="element-496">
              30% OFF — BUNDLE DISCOUNT
            </div>
          </div>

          <p className="text-gray-700 text-lg leading-relaxed text-center mb-4" data-id="element-497">
            You're about to check out with just the main guide — but the two
            most powerful resources in this system are still sitting on the
            table. Add them both now at 30% off and walk away with the complete
            toolkit to recover every dollar the system owes you.
          </p>
          <p className="text-gray-600 text-base text-center mb-8 italic" data-id="element-498">
            This bundle includes your main guide, all 3 free bonuses, PLUS both
            upgrade resources — everything you need to find, claim, and fight
            for your benefits.
          </p>

          {/* WHAT'S INCLUDED LIST */}
          <div className="bg-brand-cream p-5 rounded-xl border border-gray-200 mb-8" data-id="element-499">
            <h3 className="font-bold text-brand-dark uppercase tracking-wider text-sm mb-4 border-b border-gray-200 pb-2" data-id="element-500">
              Here is everything included:
            </h3>
            <ul className="space-y-3" data-id="element-501">
              <li className="flex items-start gap-3" data-id="element-502">
                <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-503" />
                <span className="text-gray-700 font-medium" data-id="element-504">
                  The Senior Benefit Unlocker Guide (35+ Page PDF)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-505">
                <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-506" />
                <span className="text-gray-700" data-id="element-507">
                  <strong data-id="element-508">FREE BONUS:</strong> The Missing Notice Fast Track Kit
                  (60+ Edition){' '}
                  <span className="text-gray-400 text-sm" data-id="element-509">($14.00 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-510">
                <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-511" />
                <span className="text-gray-700" data-id="element-512">
                  <strong data-id="element-513">UPGRADE:</strong> The Hidden Wealth Retirement Audit{' '}
                  <span className="text-gray-400 text-sm" data-id="element-514">($47 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-515">
                <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-516" />
                <span className="text-gray-700" data-id="element-517">
                  <strong data-id="element-518">UPGRADE:</strong> The Priority Advocacy Master System{' '}
                  <span className="text-gray-400 text-sm" data-id="element-519">($47 value)</span>
                </span>
              </li>
            </ul>
          </div>

          {/* PRICING BLOCK */}
          <div className="text-center mb-8" data-id="element-520">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-521">
              <span className="text-gray-400 line-through text-xl font-medium" data-id="element-522">
                $35.00
              </span>
              <span className="text-brand-gold font-black text-4xl" data-id="element-523">
                $24.50
              </span>
            </div>
            <p className="text-brand-dark font-bold text-sm uppercase tracking-wider mb-3" data-id="element-524">
              Special price only available on this screen
            </p>
            <div className="flex items-center justify-center gap-1.5 text-gray-500 text-sm" data-id="element-525">
              <Lock className="w-4 h-4" data-id="element-526" />
              <span data-id="element-527">Secure checkout</span>
            </div>
          </div>

          {/* CTA BUTTONS */}
          <div className="flex flex-col items-center gap-4" data-id="element-528">
            <a href="https://shopdilore.com/cart/53953717862710:1" target="_blank" rel="noopener noreferrer" onClick={onClose} className="w-full text-center px-6 py-5 text-lg md:text-xl font-bold text-brand-dark bg-brand-gold hover:bg-brand-gold-hover transition-colors rounded-lg shadow-lg cta-pulse-anim flex items-center justify-center" data-id="element-529">
              YES! I Want the Complete Package for $24.50
              <ArrowRight className="ml-3 w-6 h-6" data-id="element-530" />
            </a>

            <a href="https://www.shopdilore.com/cart/53835577721142:1" target="_blank" rel="noopener noreferrer" onClick={onClose} className="text-gray-500 hover:text-gray-800 underline underline-offset-4 text-sm md:text-base transition-colors" data-id="element-531">
              No thanks, continue without the extras →
            </a>
          </div>
        </div>
      </div>
    </div>;
}